export type Maybe<T> = T | null | undefined;

export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Date: any;
  DateTime: any;
  TimeSignalAttributeValue: any;
  UnqualifiedDateTime: any;
};

export const statusMessages = ['success', 'executing'];
export const validSettingKeys = ['title', 'helperText', 'type', 'default'];
export const validCheckboxKeys = ['label', 'value'];
export const dropdownTypes = ['dropdown', 'checkbox'];
export const dialogConnectors = ['bamboohr', 'replicon', 'computerease'];
export const oauthDialogConnectors = ['zendesk', 'vantagepoint'];

export const inputDateFormat = 'MM-DD-YYYY';

export type OnDemandConfigItem = {
  dagIdToTrigger: string;
  descriptionText: string;
  customSettings: Array<object>;
};

export const defaultConnectors = {
  wave1: ['quickbooks']
};

export enum ConnectorScope {
  All = 'ALL',
  Tenant = 'TENANT',
  User = 'USER'
}

export enum ConnectorActions {
  INSTALL = 'install',
  UNINSTALL = 'uninstall',
  MODIFY = 'modify'
}

export enum ConnectorSettingScope {
  Tenant = 'TENANT',
  User = 'USER'
}

export enum ConnectorShortNames {
  Quickbooks = 'quickbooks'
}

export enum MenuItemNames {
  Production = 'Production',
  Sandbox = 'Sandbox',
  OAuth2 = 'Oauth2.0',
  BasicAuth = 'Basic Auth',
  Modify = 'Modify'
}

export enum keyValueApi {
  email = 'notificationEmail',
  dagSettings = 'dagSettings',
  dynamicDagConfigInfo = 'dynamicDagConfigInfo'
}

export enum InstallType {
  basicAuth = 'Basic Auth',
  oauth2 = 'OAuth2',
  token = 'Token Based'
}

export enum InputType {
  TextField = 'textfield',
  Dropdown = 'dropdown',
  Checkbox = 'checkbox',
  Date = 'datefield',
  MultipleInputField = 'multipleInputField',
  RangeCriteriaSelection = 'rangeCriteriaSelection',
  LaborCode = 'laborCode'
}

export interface LaborCodeSetting {
  configureLaborCode: boolean;
  levels: string[];
}

export type UserSyncFilter = {
  field: string | null;
  condition: string | null;
  value: string | null;
};

export type DropdownOption = {
  [key: Scalars['String']]: Scalars['String'] | Scalars['Boolean'];
};

export type dagTriggered = {
  dagEcid: Scalars['String'];
};

export type CustomSetting = {
  id: Scalars['String'];
  title: Scalars['String'];
  heading?: Scalars['String'];
  description?: Scalars['String'];
  customSettings?: Array<Setting>;
  addSettingName?: Scalars['String'];
  placeholder?: Setting;
  helperTextValue: Scalars['String'];
  type: Scalars['String'];
  dropdownOptions?: Array<DropdownOption>;
  fieldOptions?: Array<DropdownOption>;
  conditionOptions?: Array<DropdownOption>;
  mandatory?: boolean;
  required?: boolean;
};

export type DagSection = {
  tab: Scalars['String'];
  arrowIcon: Scalars['Boolean'];
  dagId: Scalars['String'];
  description: Scalars['String'];
  customSettings: Array<CustomSetting>;
  mappedWorkflow?: Scalars['String'];
};

export type SlideInfo = {
  slideName: string;
  slideSrc: string;
}[];

export type ConnectorLogo = {
  src: Scalars['String'];
};

export type Connectors = {
  connectors: { items: Array<Connector> };
  companyKey: Scalars['String'];
  isPsaProduct: Scalars['Boolean'];
};

export type Connector = {
  name: Scalars['String'];
  shortName: Scalars['String'];
  category: Scalars['String'];
  isOauth2: Scalars['Boolean'];
  basicAuth: Scalars['Boolean'];
  appScope: Array<ConnectorSettingScope>;
  image: ConnectorLogo;
  descriptionTextArray: Array<Scalars['String']>;
  dagsSection: Array<DagSection>;
  installed?: Scalars['Boolean'];
  isDagsError?: Record<string, boolean>;
  installMethod?: Scalars['String'];
  repliconDocumentationLink: Scalars['String'];
  polarisDocumentationLink: Scalars['String'];
};

export type ConnectorInfo = Connector & {
  companyKey: Scalars['String'];
  isPsaProduct: Scalars['Boolean'];
};

export type DagConfig = {
  workflowId: Scalars['String'];
  enabled: Scalars['String'];
  isCustom?: Scalars['String'];
  customSettings: Record<string, Array<Setting> | string | boolean | object>;
  pendingEnable?: boolean;
  customSettingsSaved?: boolean;
};

export type DagConfigs = Array<DagConfig>;

/** Collector Specific errors. Allowing collectors to report their own unique errors */

export type Setting = {
  key: Scalars['String'];
  value: Scalars['String'] | null;
  field?: Scalars['String'] | null;
  condition?: Scalars['String'] | null;
};

export type Maintainer = {
  displayText: Scalars['String'];
  userId: Scalars['String'];
};

export type CustomTerm = {
  customTerm: Scalars['String'];
  originalTerm: Scalars['String'];
};

export type GetMeQuery = {
  me?:
    | {
        id: string;
        displayText: string;
        loginName: string;
        slug: string;
        tenantSlug: string;
        wtsUiEndpoint: string;
        firstName: string;
        lastName: string;
        companyKey: string;
        showStartEndFields?: boolean | null | undefined;
        isSmartSuggestionEnabled?: boolean | null | undefined;
        workWeekStartDay: {
          displayText?: string | null | undefined;
          uri?: string | null | undefined;
        };
        permissions: {
          hasCompanyConnectorInstallAccess: boolean;
          hasViewConnectorsAccess: boolean;
        };
      }
    | null
    | undefined;
};
